import styled from 'styled-components'

const Container = styled.div`
  color: #1a1a1a;
  
  .details-container {
    width: 100%;
    max-width: 700px;
    padding: 2rem;
    background: white;
    border-radius: 12px;

    header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding-bottom: 1.5rem;
      border-bottom: 2px solid #f0f0f0;
      margin-bottom: 2rem;

      .header-content {
        display: flex;
        align-items: center;
        gap: 1rem;

        .merchant-icon {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.8rem;
        }

        .header-text {
          h2 {
            font-size: 1.6rem;
            color: #1a1a1a;
            margin-bottom: 0.5rem;
            font-weight: 600;
          }

          .status-badge {
            padding: 0.3rem 0.8rem;
            border-radius: 20px;
            font-size: 0.85rem;
            font-weight: 500;

            &.active {
              background: #d4edda;
              color: #155724;
            }

            &.inactive {
              background: #f8d7da;
              color: #721c24;
            }
          }
        }
      }

      .header-actions {
        display: flex;
        gap: 0.5rem;

        .btn-icon {
          width: 40px;
          height: 40px;
          border-radius: 8px;
          border: 1px solid #ddd;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          color: #666;

          &:hover {
            background: #ff6b35;
            color: white;
            border-color: #ff6b35;
          }

          &.btn-delete:hover {
            background: #dc3545;
            border-color: #dc3545;
          }

          svg {
            font-size: 1rem;
          }
        }
      }
    }

    .info-section {
      margin-bottom: 2rem;

      h3 {
        font-size: 1.2rem;
        color: #1a1a1a;
        margin-bottom: 1rem;
        font-weight: 600;
      }

      .info-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5rem;

        .info-item {
          display: flex;
          gap: 1rem;
          align-items: flex-start;

          &.full-width {
            grid-column: 1 / -1;
          }

          .info-icon {
            width: 40px;
            height: 40px;
            border-radius: 8px;
            background: #f8f9fa;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ff6b35;
            flex-shrink: 0;

            svg {
              font-size: 1.1rem;
            }
          }

          .info-content {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;
            flex: 1;

            label {
              font-size: 0.85rem;
              color: #666;
              font-weight: 500;
            }

            span {
              font-size: 0.95rem;
              color: #1a1a1a;
              word-break: break-word;
            }
          }
        }
      }
    }

    .stats-section {
      margin-bottom: 2rem;
      padding: 1.5rem;
      background: #f8f9fa;
      border-radius: 12px;

      h3 {
        font-size: 1.2rem;
        color: #1a1a1a;
        margin-bottom: 1.5rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 0.5rem;

        svg {
          color: #ff6b35;
        }
      }

      .stats-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;

        .stat-card {
          background: white;
          padding: 1.25rem;
          border-radius: 8px;
          text-align: center;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

          .stat-value {
            font-size: 1.8rem;
            font-weight: 700;
            color: #ff6b35;
            margin-bottom: 0.5rem;
          }

          .stat-label {
            font-size: 0.85rem;
            color: #666;
          }
        }
      }

      .loading-stats,
      .no-stats {
        text-align: center;
        color: #999;
        padding: 2rem;
        font-style: italic;
      }
    }

    .dates-section {
      display: flex;
      gap: 2rem;
      padding-top: 1.5rem;
      border-top: 2px solid #f0f0f0;

      .date-item {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;

        label {
          font-size: 0.85rem;
          color: #666;
          font-weight: 500;
        }

        span {
          font-size: 0.95rem;
          color: #1a1a1a;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .details-container {
      padding: 1.5rem;

      header {
        flex-direction: column;
        gap: 1rem;

        .header-content {
          .merchant-icon {
            width: 50px;
            height: 50px;
            font-size: 1.5rem;
          }

          .header-text h2 {
            font-size: 1.3rem;
          }
        }

        .header-actions {
          align-self: flex-end;
        }
      }

      .info-section .info-grid {
        grid-template-columns: 1fr;
        gap: 1rem;

        .info-item.full-width {
          grid-column: 1;
        }
      }

      .stats-section .stats-grid {
        grid-template-columns: repeat(2, 1fr);
      }

      .dates-section {
        flex-direction: column;
        gap: 1rem;
      }
    }
  }

  @media (max-width: 480px) {
    .stats-section .stats-grid {
      grid-template-columns: 1fr;
    }
  }
`

export default Container
